import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../motion/Reveal";
import { IMAGES } from "../../data/site";
import { useSiteData, fileUrl } from "../../context/SiteData";

export const RoomCard = ({ room, delay = 0 }) => {
  const { images, loaded } = useSiteData();
  const src = images[`room-${room.slug}`]
    ? fileUrl(images[`room-${room.slug}`])
    : loaded
      ? room.image || IMAGES.roomExtra
      : null;

  return (
    <Reveal delay={delay} className="h-full">
      <article
        data-testid={`room-card-${room.slug}`}
        className="group card-lift flex h-full flex-col border border-line bg-white hover:bg-cream-100"
      >
        <Link to={`/odalar/${room.slug}`} className="relative block overflow-hidden">
          <div className="aspect-[4/3] w-full overflow-hidden">
            {src ? (
              <img
                src={src}
                alt={room.name}
                loading="lazy"
                className="h-full w-full object-cover saturate-[0.9] transition-[transform,filter] duration-700 ease-out group-hover:scale-[1.03] group-hover:saturate-100"
              />
            ) : (
              <div className="h-full w-full animate-pulse bg-cream-200" />
            )}
          </div>
          <span className="absolute bottom-0 left-0 h-[3px] w-full origin-left scale-x-0 bg-ink-900 transition-transform duration-500 ease-out group-hover:scale-x-100" />
        </Link>
        <div className="flex flex-1 flex-col p-6 sm:p-7">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-ink-400">
            {room.capacity}
          </p>
          <h3 className="mt-2 text-xl font-bold tracking-tight text-ink-900 transition-transform duration-500 group-hover:translate-x-1 sm:text-2xl">
            {room.name}
          </h3>
          <p className="mt-3 flex-1 text-sm leading-relaxed text-ink-500">{room.short}</p>
          <p className="mt-4 text-xs font-medium uppercase tracking-[0.14em] text-ink-400">
            {room.features.slice(0, 3).join(" · ")}
          </p>
          <Link
            to={`/odalar/${room.slug}`}
            data-testid={`room-card-link-${room.slug}`}
            className="link-arrow mt-6 border-t border-line pt-5"
          >
            Detayları Gör
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </article>
    </Reveal>
  );
};
